
import styles from './SearchResItem.module.css'
import { Link } from 'react-router-dom'
import { GoMilestone } from "react-icons/go";
import { useLanguage } from '../contexts/LanguageContext'

// Компонент отображающий поисковую ссылку
function SearchResItem({link, text, language}){
    // Add language-specific tooltip if needed
    const linkTitle = language === 'eng' 
        ? `Go to ${text}` 
        : `Перейти к ${text}`
    
    return (
        <div className={styles.SearchResItem}>
            <span><GoMilestone /></span>
            <Link 
                to={link} 
                title={linkTitle}
            >
                {text}
            </Link> 
        </div>
    )
}

export default SearchResItem
